export { default } from './IntegrationLabel'

export { IntegrationLabelTypes } from './IntegrationLabel.const'
